import React from 'react';
import { InputProps } from 'antd';
import msk from 'msk';

import LtrInput from './LtrInput';

const EMIRATES_ID_MASK = '784-XXXX-YYYYYYY-Z';

const m = (value: any) => msk(value?.toString() || '', EMIRATES_ID_MASK);

const EmiratesIdInput: React.FC<InputProps> = (props) => {
  const { value, onChange, ...rest } = props;

  return (
    <LtrInput
      value={m(value)}
      onChange={(e) => {
        const cursorPosition = e.target.selectionStart;
        const newValue = e.target.value || '';
        // eslint-disable-next-line no-param-reassign
        e.target.value = m(newValue.toString().replace(/[^0-9]/g, ''));
        onChange?.(e);
        const selectionRange =
          e.target.value[(cursorPosition || 0) - 1] === '-' ? (cursorPosition || 0) + 1 : cursorPosition;
        e.target.setSelectionRange(selectionRange, selectionRange);
      }}
      {...rest}
    />
  );
};

export default EmiratesIdInput;
